import scrollParent from './scroll-parent';

export default function getScrollOffset() {
  const parent = scrollParent();
  return parent.scrollY || parent.scrollTop || 0;
}
